(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cortex-help-center"] && !Shopify.designMode) return;
  try {
    
function initializeCortexHelp(root){
 if(root.dataset.ready)return;
 root.dataset.ready='true';
 /* Nov 2, 2026: product search label wording (the label itself lives in snippets/cortex-tool-finder.liquid) */
 const productLabel=root.querySelector('label[for="CortexProductSearch"]');if(productLabel)productLabel.textContent='Product name -or- SKU (style number)';
 ['wonder-smooth','secret-straight','nutri-curls','power-blonde','purifying-detox','silk-obsessed','vivid-color'].forEach(id=>{const old=root.querySelector('#guide-'+id);if(old)old.remove();});
 const library=root.querySelector('.cortex-library:not(.cortex-tool-finder)');
 if(library){let el=library.querySelector('p');el=el&&el.nextElementSibling;while(el&&el.tagName!=='LABEL'&&el.tagName!=='SELECT'){el.hidden=true;el=el.nextElementSibling;}}
 const input=root.querySelector('[data-help-input]'),topic=root.querySelector('[data-help-topic]'),productInput=root.querySelector('[data-product-search]');
 const answers=Array.from(root.querySelectorAll('[data-help-answer]'));
 const normalize=value=>value.toLocaleLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9\s]/g,' ');
 const words=value=>normalize(value).trim().split(/\s+/).filter(Boolean);
 const terms=answers.map(a=>normalize(a.textContent+' '+(a.dataset.keywords||'')));
 const productTotal=answers.filter(a=>a.hasAttribute('data-product-entry')).length;
 let selectedCategory='';
 const categoryLinks=Array.from(root.querySelectorAll('[data-tool-category]'));
 const filter=()=>{
  const query=words(input.value),productQuery=words(productInput.value);let count=0,productCount=0;
  const browsing=!query.length&&!topic.value;
  answers.forEach((a,i)=>{
   const product=a.hasAttribute('data-product-entry');
   let match=query.every(w=>terms[i].includes(w))&&(!topic.value||a.dataset.category===topic.value)&&(!product||(productQuery.every(w=>terms[i].includes(w))&&(!selectedCategory||(a.dataset.toolCategories||'').split(' ').includes(selectedCategory))));
   if(match&&browsing&&!product&&!a.hasAttribute('data-help-top'))match=false;
   a.hidden=!match;if(match){count++;if(product)productCount++;}
  });
  root.querySelector('[data-help-empty]').hidden=count!==0;
  root.querySelector('[data-help-status]').textContent=browsing?'*Search '+answers.length+' answers + tutorials':count+' of '+answers.length+' answers + tutorials';
  const note=root.querySelector('[data-help-top-note]');if(note)note.hidden=!browsing;
  root.querySelector('[data-product-status]').textContent=productCount+' of '+productTotal+' product tutorials';
  root.querySelector('[data-product-empty]').hidden=productCount!==0;
 };
 const selectCategory=(key,scroll)=>{
  selectedCategory=key;input.value='';topic.value='';productInput.value='';
  categoryLinks.forEach(link=>{if(link.dataset.toolCategory===key)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});
  filter();
  const active=categoryLinks.find(link=>link.dataset.toolCategory===key);
  const heading=root.querySelector('[data-product-heading]');
  heading.textContent=key&&active?active.querySelector('strong').textContent:heading.dataset.defaultText;
  if(scroll){heading.focus({preventScroll:true});heading.scrollIntoView({block:'start',behavior:'instant'});}
 };
 const productHeading=root.querySelector('[data-product-heading]');productHeading.dataset.defaultText=productHeading.textContent;
 root.querySelectorAll('a[href="#cortex-product-guides"]').forEach(link=>link.addEventListener('click',()=>selectCategory('',false)));
 categoryLinks.forEach(link=>link.addEventListener('click',event=>{event.preventDefault();const hash=link.getAttribute('href');history.pushState(null,'',hash);selectCategory(link.dataset.toolCategory,true);}));
 const restoreCategory=()=>{const id=location.hash.slice(1);if(id.startsWith('tools-')){const key=id.slice(6)==='all'?'':id.slice(6);if(categoryLinks.some(link=>link.dataset.toolCategory===key))selectCategory(key,true);}else if(selectedCategory)selectCategory('',false);};
 root.querySelector('[data-help-search]').hidden=false;
 input.addEventListener('input',filter);topic.addEventListener('change',filter);productInput.addEventListener('input',filter);
 root.querySelectorAll('[data-help-top-note] a').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();input.scrollIntoView({block:'center'});input.focus({preventScroll:true});}));
 const openGuide=()=>{const id=location.hash.slice(1);if(!id.startsWith('guide-'))return;const guide=document.getElementById(id);if(!guide||!root.contains(guide))return;selectCategory('',false);guide.hidden=false;guide.open=true;guide.scrollIntoView({block:'start'});};
 window.addEventListener('hashchange',()=>{restoreCategory();openGuide();});filter();restoreCategory();openGuide();
}
document.querySelectorAll('[data-cortex-help]').forEach(initializeCortexHelp);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-cortex-help]').forEach(initializeCortexHelp));

  } catch(e) { console.error(e); }
})();
})();
